import React from "react";
import YLayout from "./YLayout";

const App: React.FC = () => <YLayout />;

export default App;
